import { animate, state, style, transition, trigger } from '@angular/animations';
import { NgStyle } from '@angular/common';
import { Component, Input, OnInit, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort, SortDirection } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { eq, slice } from 'lodash';
import { ColumnData, Pagination, TableConfig, TableSort } from './common-table-interface';
import multiSort from './multi-sort-function';

@Component({
    selector: 'common-table',
    templateUrl: './common-table.component.html',
    styleUrls: ['./common-table.component.scss'],
    animations: [
        trigger('detailExpand', [
            state('collapsed, void', style({ height: '0px', minHeight: '0', display: 'none' })),
            state('expanded', style({ height: '*', padding: '1rem' })),
            transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
        ]),
    ],
    standalone: false
})

export class CommonTableComponent implements OnInit {

  expandedElement!: boolean;

  @Input() idx: string | undefined;
  @Input() tableConfig!: TableConfig;
  @Input() tableData!: Array<Object>;
  @Input() expandDataKey: string | undefined;
  @Input() expandTemplate: TemplateRef<any> | undefined;
  @Input() dataTemplate: TemplateRef<any> | undefined;
  @Input() rowExpandable!: boolean;

  dataSource = new MatTableDataSource(this.tableData);
  columnsToDisplay!: string[];
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  constructor() { }

  ngOnChanges(changes: SimpleChanges) {
    console.log(changes.tableData.currentValue);
    this.dataSource.data = changes.tableData.currentValue;
  }

  ngOnInit(): void {
    if(!this.tableData) {
      console.log('no data for table');
    } else {
      this.setDefaultColumnWidth();
      this.dataSource.data = this.tableData;
      const array: any[] = [];
      for (let i in this.tableConfig.columns) {
        array[i] = this.tableConfig.columns[i].columnDef;
      }
      this.columnsToDisplay = array;
      if (this.rowExpandable) {
        this.columnsToDisplay.push('expand');
      }
    //console.log(this.tableConfig);
    }
    if(this.paginator) {
      this.paginator._intl.firstPageLabel = '';
      this.paginator._intl.lastPageLabel = '';
    }
  }

  ngAfterViewInit() {
    if(this.tableConfig.pagination?.showPagination) {
      this.dataSource.paginator = this.paginator;
      this.setPageNumbers();
      this.paginator.page.subscribe(() => {
        this.setPageNumbers();
      });
    }
    if(this.tableConfig.tableSort?.enableSorting) {
      this.sort.active = this.tableConfig.tableSort.sortActive ?? this.tableConfig.columns[0].columnDef
      this.sort.direction = this.tableConfig.tableSort.sortDirection ?? 'asc';
      this.dataSource.data = multiSort(this.dataSource.data, this.sort, this.tableConfig.columns);
    }
  }

  sortData(sort: Sort) {
    this.dataSource.data = multiSort(this.dataSource.data, sort, this.tableConfig.columns);
    this.paginator.firstPage();
    return this.dataSource.data;
  }

  setPageNumbers() {
    this.paginator._intl.getRangeLabel = (page: number, pageSize: number, length: number) => {
      if (length == 0 || pageSize == 0) {
        return `0 of ${length}`;
      }
      const totalPagesNum = Math.ceil(length/pageSize);
      return `Page ${page + 1} of ${totalPagesNum}`;
    };
    
    // set aria-hidden=true for prev and next buttons icons
    const iconList = document.getElementsByClassName('mat-paginator-icon');
    for(let i=0; i<iconList.length; i++) {
      iconList[i].setAttribute('aria-hidden', 'true');
    } 
  }

  setDefaultColumnWidth() {
    let eachColumnWidth = 0;
    if(this.rowExpandable) {
      eachColumnWidth = 90 / this.tableConfig.columns.length;
    } else {
      eachColumnWidth = 100 / this.tableConfig.columns.length;
    }
    this.tableConfig.columns.forEach((item) => {
      if(!item.columnWidth) {
        item.columnWidth = eachColumnWidth.toString() + '%';
      }
    });
  }
}
